import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  guid: null,
  title: null,
};

export const selectedFarmerDashboardSlice = createSlice({
  name: "selectedFarmerDashboard",
  initialState,
  reducers: {
    setSelectedFarmerDashboard: (state, action) => {
      state.guid = action.payload.guid;
      state.title = action.payload.title;
    },
  },
});

export const { setSelectedFarmerDashboard } =
  selectedFarmerDashboardSlice.actions;

export const selectedFarmerDashboardReducer =
  selectedFarmerDashboardSlice.reducer;
